export default function ({ store, redirect }) {
  // 1. Check if user is logged in
  // Assuming you use the Nuxt Auth module or a custom Vuex store
  const isSigned = store.state.auth.isSigned;
  if (!isSigned) {
    return redirect('/login');
  }

  // 2. Check the subscription status from your Vuex store
  // Make sure your UserSubscription model data is synced to Vuex
  const subscription = store.state.auth.user.subscription;
  const status = subscription ? subscription.status : null;

  // Grant access if status is 'active' or 'canceled' (grace period)
  const hasAccess = status === 'active' || status === 'canceled';

  if (!hasAccess) {
    return redirect('/mem');
  }
}